import { jsx as _jsx } from "react/jsx-runtime";
import { StyledImage, StyledWrapper } from './ProfilePicture.style';
export function ProfilePicture({ userName, sourceUrl, active = false, }) {
    return (_jsx(StyledWrapper, { active: active, title: userName, children: _jsx(StyledImage, { sourceUrl: sourceUrl }) }));
}
//# sourceMappingURL=ProfilePicture.js.map